import { Button } from "@components/atoms/Button"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Appear } from "@components/motion/Appear"
import { cn } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "CTA",
  tags: ["#page"],
}

export default defineBlock("content/cta", (props) => {
  return (
    <div className="content-sized my-blockSpace flex flex-col md:flex-row items-center justify-between gap-4">
      <Appear
        className={cn(
          "w-full rounded-sm bg-slate200 overflow-hidden flex items-center justify-center self-stretch aspect-[352/256] md:aspect-auto",
          !props.image && "aspect-[352/512] md:aspect-[1056/320]",
        )}
        style={{
          backgroundImage: `url("${env.themePath}/assets/images/patterns/plus.svg")`,
          backgroundRepeat: "repeat",
          backgroundSize: "var(--spacing-7) var(--spacing-7)",
        }}
      >
        <div className="flex flex-col gap-5 md:gap-4 items-center justify-center">
          <Appear slide delay={100}>
            <EditableText
              store="ctaText"
              className="type-serif-2-xl-regular md:type-serif-3-xl-regular text-pretty text-center"
              defaultValue="Partner with Bakkt."
              placeholder="CTA Text"
            />
          </Appear>
          <Appear delay={200}>
            <Button
              variant="orange"
              href={props.buttonLink?.url || undefined}
              target={props.buttonLink?.target || undefined}
            >
              {props.buttonLink?.title || "Book Your Consult"}
            </Button>
          </Appear>
        </div>
      </Appear>
      {props.image && (
        <Appear
          delay={250}
          className="w-full md:w-cols-4 aspect-[352/256] md:aspect-square shrink-0 bg-slate600 rounded-sm overflow-hidden"
        >
          <Appear zoom duration={1000} className="w-full h-full">
            <ResponsiveImage {...props.image} className="w-full h-full" objectFit="cover" />
          </Appear>
        </Appear>
      )}
    </div>
  )
})
